jQuery(document).ready(function ($) {
    let $cartTrigger = $("#cart-trigger");
    let $sideCart = $("#side-cart");
    let $closeCart = $("#close-cart");
    let $cartOverlay = $("#cart-overlay");

    // Open cart
    $cartTrigger.on("click", function () {
        $sideCart.addClass("open");
        $cartOverlay.addClass("active");
    });

    // Close cart
    $closeCart.on("click", function () {
        $sideCart.removeClass("open");
        $cartOverlay.removeClass("active");
    });

    $cartOverlay.on("click", function () {
        $sideCart.removeClass("open");
        $cartOverlay.removeClass("active");
    });

    // Event delegation for quantity update
    $(document).on("change", ".cart-qty", function () {
        let cartItemKey = $(this).data("cart-item-key");
        let quantity = $(this).val();

        $.post(wc_add_to_cart_params.ajax_url, {
            action: "update_cart_item",
            cart_item_key: cartItemKey,
            quantity: quantity
        }).done(function () {
            $(document.body).trigger("wc_fragment_refresh");
            $.post(wc_add_to_cart_params.wc_ajax_url.replace("%%endpoint%%", "get_refreshed_fragments"), function(response) {
                if (response && response.fragments && response.fragments['p#mini-cart-total']) {
                     $('#mini-cart-total').replaceWith(response.fragments['p#mini-cart-total']);
                }
            });
            updateCartCount();
        });
    });

    // Event delegation for removing item
    $(document).on("click", ".woocommerce-mini-cart-item .remove_from_cart_button", function (e) {
        e.preventDefault();
        let cartItemKey = $(this).data("cart-item-key");

        $.post(wc_add_to_cart_params.ajax_url, {
            action: "remove_cart_item",
            cart_item_key: cartItemKey
        }).done(function (response) {
            $(document.body).trigger("wc_fragment_refresh");
            $.post(wc_add_to_cart_params.wc_ajax_url.replace("%%endpoint%%", "get_refreshed_fragments"), function(response) {
                if (response && response.fragments && response.fragments['div.woocommerce-mini-cart']) {
                    $('div.woocommerce-mini-cart').replaceWith(response.fragments['div.woocommerce-mini-cart']);
                }
            });
            updateCartCount();
        }).fail(function (error) {
            console.error('Error removing item:', error);
        });
    });

    // update header shopping cart count
    function updateCartCount() {
        $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: { action: 'get_cart_contents_count' },
            success: function (response) {
                if (response.success) {
                    $('#cart-count').text(response.data.count);
                }
            },
            error: function (error) {
                console.error('Error updating cart count:', error);
            }
        });
    }

    $(document.body).on('added_to_cart removed_from_cart', function () {
        updateCartCount();
    });
});
